import { useEffect, useState } from "react";
import { UsuarioService } from "../../service/UsuarioService";
import { Checkbox } from "primereact/checkbox";
import { Column } from "primereact/column";
import { useLazyParams } from "../../hooks/useLazyParams";
import { TablaDinamica } from "../../components/TablaDinamica";
import { Generico } from "../../components/Generico";
import { EmpresaUsuarioGrupo as EmpresaGrupoModel } from "../../models/administracion/EmpresaUsuarioGrupo";

export const EmpresaUsuarioGrupo = ({ id, toast, permss }) => {

    const tablaEstado = useLazyParams({ modelo: EmpresaGrupoModel });
    const [sasignar, setSasignar] = useState([]);
    const usuarioService = new UsuarioService();
    const { funcSuccess, funcSistemaError } = Generico();

    useEffect(() => {
        loadLazyData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tablaEstado.lazyParams, id]);

    const loadLazyData = () => {
        const params = { ...tablaEstado.lazyParams, usuario: id, tipo: "grupo" };
        tablaEstado.setLoading(true);
        usuarioService.getUsuarioEmpresa({ lazyEvent: JSON.stringify(params) }).then(res => {
            tablaEstado.setTotalRecords(res.data.total);
            tablaEstado.setData(res.data.registros);
            const inicial = [];
            res.data.registros.forEach(item => { if (item.fecha != null) { inicial.push(item.id); } });
            setSasignar(inicial);
        }).catch(error => {
            funcSistemaError(error, toast);
        }).finally(() => {
            tablaEstado.setLoading(false);
        });
    }

    const asignar = (e, rowData) => {
        const checked = e.checked;
        const idGrupo = rowData.id;
        setFilaLoading(idGrupo, true);
        tablaEstado.setLoading(true);
        usuarioService.putEmpresa({ id: idGrupo, usu: id, agregar: checked, tipo: "grupo" }).then(res => {
            funcSuccess(res, toast);
            tablaEstado.refreshData();
        }).catch(error => {
            funcSistemaError(error, toast);
            setFilaLoading(idGrupo, false);
            tablaEstado.setLoading(false);
        });
    }

    const setFilaLoading = (idGrupo, isLoading) => {
        tablaEstado.setData(prevData => {
            return prevData.map(row => {
                if (row.id === idGrupo) { return { ...row, loading: isLoading }; }
                return row;
            });
        });
    };

    const actionBodyTemplate = (rowData) => {
        if (!permss.crear && !permss.actualizar) return null;
        const isProcessing = rowData.loading === true;
        return (
            <div className="actions flex justify-content-center">
                {isProcessing ? (
                    <i className="pi pi-spin pi-spinner" style={{ fontSize: '1.5rem', color: 'var(--primary-color)' }}></i>
                ) : (
                    <Checkbox value={rowData.id} checked={sasignar.includes(rowData.id)} onChange={(e) => asignar(e, rowData)} />
                )}
            </div>
        );
    };

    const ColumnaAcciones = (
        <Column header='Asignar / Quitar' body={actionBodyTemplate} style={{ textAlign: 'center', width: '10rem' }} />
    );

    return (
        <>
            <h6>*Lista de empresas en formularios</h6>
            <TablaDinamica modelo={EmpresaGrupoModel} estadoTabla={tablaEstado} datos={tablaEstado.data} totalRegistros={tablaEstado.totalRecords} dataKey="id" acciones={ColumnaAcciones} className="datatable-responsive" />
        </>
    )
}
